
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the client.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/client"
import type * as Prisma from "../models"
import { type PrismaClient } from "./class"

export type * from '../models'

export type DMMF = typeof runtime.DMMF

export type PrismaPromise<T> = runtime.Types.Public.PrismaPromise<T>

/**
 * Prisma Errors
 */

export const PrismaClientKnownRequestError = runtime.PrismaClientKnownRequestError
export type PrismaClientKnownRequestError = runtime.PrismaClientKnownRequestError

export const PrismaClientUnknownRequestError = runtime.PrismaClientUnknownRequestError
export type PrismaClientUnknownRequestError = runtime.PrismaClientUnknownRequestError

export const PrismaClientRustPanicError = runtime.PrismaClientRustPanicError
export type PrismaClientRustPanicError = runtime.PrismaClientRustPanicError

export const PrismaClientInitializationError = runtime.PrismaClientInitializationError
export type PrismaClientInitializationError = runtime.PrismaClientInitializationError

export const PrismaClientValidationError = runtime.PrismaClientValidationError
export type PrismaClientValidationError = runtime.PrismaClientValidationError

/**
 * Re-export of sql-template-tag
 */
export const sql = runtime.sqltag
export const empty = runtime.empty
export const join = runtime.join
export const raw = runtime.raw
export const Sql = runtime.Sql
export type Sql = runtime.Sql



/**
 * Decimal.js
 */
export const Decimal = runtime.Decimal
export type Decimal = runtime.Decimal

export type DecimalJsLike = runtime.DecimalJsLike

/**
* Extensions
*/
export type Extension = runtime.Types.Extensions.UserArgs
export const getExtensionContext = runtime.Extensions.getExtensionContext
export type Args<T, F extends runtime.Operation> = runtime.Types.Public.Args<T, F>
export type Payload<T, F extends runtime.Operation = never> = runtime.Types.Public.Payload<T, F>
export type Result<T, A, F extends runtime.Operation> = runtime.Types.Public.Result<T, A, F>
export type Exact<A, W> = runtime.Types.Public.Exact<A, W>

export type PrismaVersion = {
  client: string
  engine: string
}

/**
 * Prisma Client JS version: 7.8.0
 * Query Engine version: 3c6e192761c0362d496ed980de936e2f3cebcd3a
 */
export const prismaVersion: PrismaVersion = {
  client: "7.8.0",
  engine: "3c6e192761c0362d496ed980de936e2f3cebcd3a"
}

/**
 * Utility Types
 */

export type Bytes = runtime.Bytes
export type JsonObject = runtime.JsonObject
export type JsonArray = runtime.JsonArray
export type JsonValue = runtime.JsonValue
export type InputJsonObject = runtime.InputJsonObject
export type InputJsonArray = runtime.InputJsonArray
export type InputJsonValue = runtime.InputJsonValue


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


type SelectAndInclude = {
  select: any
  include: any
}

type SelectAndOmit = {
  select: any
  omit: any
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
type Prisma__Pick<T, K extends keyof T> = {
    [P in K]: T[P];
};

export type Enumerable<T> = T | Array<T>;

/**
 * Subset
 * @desc From `T` pick properties that exist in `U`. Simple version of Intersection
 */
export type Subset<T, U> = {
  [key in keyof T]: key extends keyof U ? T[key] : never;
};

/**
 * SelectSubset
 * @desc From `T` pick properties that exist in `U`. Simple version of Intersection.
 * Additionally, it validates, if both select and include are present. If the case, it errors.
 */
export type SelectSubset<T, U> = {
  [key in keyof T]: key extends keyof U ? T[key] : never
} &
  (T extends SelectAndInclude
    ? 'Please either choose `select` or `include`.'
    : T extends SelectAndOmit
      ? 'Please either choose `select` or `omit`.'
      : {})

/**
 * Subset + Intersection
 * @desc From `T` pick properties that exist in `U` and intersect `K`
 */
export type SubsetIntersection<T, U, K> = {
  [key in keyof T]: key extends keyof U ? T[key] : never
} &
  K

type Without<T, U> = { [P in Exclude<keyof T, keyof U>]?: never };

/**
 * XOR is needed to have a real mutually exclusive union type
 * https://stackoverflow.com/questions/42123407/does-typescript-support-mutually-exclusive-types
 */
export type XOR<T, U> =
  T extends object ?
  U extends object ?
    (Without<T, U> & U) | (Without<U, T> & T)
  : U : T


/**
 * Is T a Record?
 */
type IsObject<T extends any> = T extends Array<any>
? False
: T extends Date
? False
: T extends Uint8Array
? False
: T extends BigInt
? False
: T extends object
? True
: False


/**
 * If it's T[], return T
 */
export type UnEnumerate<T extends unknown> = T extends Array<infer U> ? U : T

/**
 * From ts-toolbelt
 */

type __Either<O extends object, K extends Key> = Omit<O, K> &
  {
    // Merge all but K
    [P in K]: Prisma__Pick<O, P & keyof O> // With K possibilities
  }[K]

type EitherStrict<O extends object, K extends Key> = Strict<__Either<O, K>>

type EitherLoose<O extends object, K extends Key> = ComputeRaw<__Either<O, K>>

type _Either<
  O extends object,
  K extends Key,
  strict extends Boolean
> = {
  1: EitherStrict<O, K>
  0: EitherLoose<O, K>
}[strict]

export type Either<
  O extends object,
  K extends Key,
  strict extends Boolean = 1
> = O extends unknown ? _Either<O, K, strict> : never

export type Union = any

export type PatchUndefined<O extends object, O1 extends object> = {
  [K in keyof O]: O[K] extends undefined ? At<O1, K> : O[K]
} & {}

/** Helper Types for "Merge" **/
export type IntersectOf<U extends Union> = (
  U extends unknown ? (k: U) => void : never
) extends (k: infer I) => void
  ? I
  : never

export type Overwrite<O extends object, O1 extends object> = {
    [K in keyof O]: K extends keyof O1 ? O1[K] : O[K];
} & {};

type _Merge<U extends object> = IntersectOf<Overwrite<U, {
    [K in keyof U]-?: At<U, K>;
}>>;

type Key = string | number | symbol;
type AtStrict<O extends object, K extends Key> = O[K & keyof O];
type AtLoose<O extends object, K extends Key> = O extends unknown ? AtStrict<O, K> : never;
export type At<O extends object, K extends Key, strict extends Boolean = 1> = {
    1: AtStrict<O, K>;
    0: AtLoose<O, K>;
}[strict];

export type ComputeRaw<A extends any> = A extends Function ? A : {
  [K in keyof A]: A[K];
} & {};

export type OptionalFlat<O> = {
  [K in keyof O]?: O[K];
} & {};

type _Record<K extends keyof any, T> = {
  [P in K]: T;
};

// cause typescript not to expand types and preserve names
type NoExpand<T> = T extends unknown ? T : never;

// this type assumes the passed object is entirely optional
export type AtLeast<O extends object, K extends string> = NoExpand<
  O extends unknown
  ? | (K extends keyof O ? { [P in K]: O[P] } & O : O)
    | {[P in keyof O as P extends K ? P : never]-?: O[P]} & O
  : never>;

type _Strict<U, _U = U> = U extends unknown ? U & OptionalFlat<_Record<Exclude<Keys<_U>, keyof U>, never>> : never;

export type Strict<U extends object> = ComputeRaw<_Strict<U>>;
/** End Helper Types for "Merge" **/

export type Merge<U extends object> = ComputeRaw<_Merge<Strict<U>>>;

export type Boolean = True | False

export type True = 1

export type False = 0

export type Not<B extends Boolean> = {
  0: 1
  1: 0
}[B]

export type Extends<A1 extends any, A2 extends any> = [A1] extends [never]
  ? 0 // anything `never` is false
  : A1 extends A2
  ? 1
  : 0

export type Has<U extends Union, U1 extends Union> = Not<
  Extends<Exclude<U1, U>, U1>
>

export type Or<B1 extends Boolean, B2 extends Boolean> = {
  0: {
    0: 0
    1: 1
  }
  1: {
    0: 1
    1: 1
  }
}[B1][B2]

export type Keys<U extends Union> = U extends unknown ? keyof U : never

export type GetScalarType<T, O> = O extends object ? {
  [P in keyof T]: P extends keyof O
    ? O[P]
    : never
} : never

type FieldPaths<
  T,
  U = Omit<T, '_avg' | '_sum' | '_count' | '_min' | '_max'>
> = IsObject<T> extends True ? U : T

export type GetHavingFields<T> = {
  [K in keyof T]: Or<
    Or<Extends<'OR', K>, Extends<'AND', K>>,
    Extends<'NOT', K>
  > extends True
    ? // infer is only needed to not hit TS limit
      // based on the brilliant idea of Pierre-Antoine Mills
      // https://github.com/microsoft/TypeScript/issues/30188#issuecomment-478938437
      T[K] extends infer TK
      ? GetHavingFields<UnEnumerate<TK> extends object ? Merge<UnEnumerate<TK>> : never>
      : never
    : {} extends FieldPaths<T[K]>
    ? never
    : K
}[keyof T]

/**
 * Convert tuple to union
 */
type _TupleToUnion<T> = T extends (infer E)[] ? E : never
type TupleToUnion<K extends readonly any[]> = _TupleToUnion<K>
export type MaybeTupleToUnion<T> = T extends any[] ? TupleToUnion<T> : T

/**
 * Like `Pick`, but additionally can also accept an array of keys
 */
export type PickEnumerable<T, K extends Enumerable<keyof T> | keyof T> = Prisma__Pick<T, MaybeTupleToUnion<K>>

/**
 * Exclude all keys with underscores
 */
export type ExcludeUnderscoreKeys<T extends string> = T extends `_${string}` ? never : T


export type FieldRef<Model, FieldType> = runtime.FieldRef<Model, FieldType>

type FieldRefInputType<Model, FieldType> = Model extends never ? never : FieldRef<Model, FieldType>


export const ModelName = {
  User: 'User',
  Session: 'Session',
  Website: 'Website',
  WebsiteEvent: 'WebsiteEvent',
  EventData: 'EventData',
  SessionData: 'SessionData',
  Team: 'Team',
  TeamUser: 'TeamUser',
  Report: 'Report',
  Segment: 'Segment',
  Revenue: 'Revenue',
  Link: 'Link',
  Pixel: 'Pixel',
  Board: 'Board',
  Share: 'Share',
  SessionReplay: 'SessionReplay',
  SessionReplaySaved: 'SessionReplaySaved'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]



export interface TypeMapCb<GlobalOmitOptions = {}> extends runtime.Types.Utils.Fn<{extArgs: runtime.Types.Extensions.InternalArgs }, runtime.Types.Utils.Record<string, any>> {
  returns: TypeMap<this['params']['extArgs'], GlobalOmitOptions>
}

export type TypeMap<ExtArgs extends runtime.Types.Extensions.InternalArgs = runtime.Types.Extensions.DefaultArgs, GlobalOmitOptions = {}> = {
  globalOmitOptions: {
    omit: GlobalOmitOptions
  }
  meta: {
    modelProps: "user" | "session" | "website" | "websiteEvent" | "eventData" | "sessionData" | "team" | "teamUser" | "report" | "segment" | "revenue" | "link" | "pixel" | "board" | "share" | "sessionReplay" | "sessionReplaySaved"
    txIsolationLevel: TransactionIsolationLevel
  }
  model: {
    User: {
      payload: Prisma.$UserPayload<ExtArgs>
      fields: Prisma.UserFieldRefs
      operations: {
        findUnique: {
          args: Prisma.UserFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.UserFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>
        }
        findFirst: {
          args: Prisma.UserFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.UserFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>
        }
        findMany: {
          args: Prisma.UserFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>[]
        }
        create: {
          args: Prisma.UserCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>
        }
        createMany: {
          args: Prisma.UserCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.UserCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>[]
        }
        delete: {
          args: Prisma.UserDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>
        }
        update: {
          args: Prisma.UserUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>
        }
        deleteMany: {
          args: Prisma.UserDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.UserUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.UserUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>[]
        }
        upsert: {
          args: Prisma.UserUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$UserPayload>
        }
        aggregate: {
          args: Prisma.UserAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateUser>
        }
        groupBy: {
          args: Prisma.UserGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.UserGroupByOutputType>[]
        }
        count: {
          args: Prisma.UserCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.UserCountAggregateOutputType> | number
        }
      }
    }
    Session: {
      payload: Prisma.$SessionPayload<ExtArgs>
      fields: Prisma.SessionFieldRefs
      operations: {
        findUnique: {
          args: Prisma.SessionFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.SessionFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>
        }
        findFirst: {
          args: Prisma.SessionFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.SessionFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>
        }
        findMany: {
          args: Prisma.SessionFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>[]
        }
        create: {
          args: Prisma.SessionCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>
        }
        createMany: {
          args: Prisma.SessionCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.SessionCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>[]
        }
        delete: {
          args: Prisma.SessionDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>
        }
        update: {
          args: Prisma.SessionUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>
        }
        deleteMany: {
          args: Prisma.SessionDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.SessionUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.SessionUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>[]
        }
        upsert: {
          args: Prisma.SessionUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionPayload>
        }
        aggregate: {
          args: Prisma.SessionAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateSession>
        }
        groupBy: {
          args: Prisma.SessionGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionGroupByOutputType>[]
        }
        count: {
          args: Prisma.SessionCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionCountAggregateOutputType> | number
        }
      }
    }
    Website: {
      payload: Prisma.$WebsitePayload<ExtArgs>
      fields: Prisma.WebsiteFieldRefs
      operations: {
        findUnique: {
          args: Prisma.WebsiteFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.WebsiteFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>
        }
        findFirst: {
          args: Prisma.WebsiteFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.WebsiteFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>
        }
        findMany: {
          args: Prisma.WebsiteFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>[]
        }
        create: {
          args: Prisma.WebsiteCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>
        }
        createMany: {
          args: Prisma.WebsiteCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.WebsiteCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>[]
        }
        delete: {
          args: Prisma.WebsiteDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>
        }
        update: {
          args: Prisma.WebsiteUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>
        }
        deleteMany: {
          args: Prisma.WebsiteDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.WebsiteUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.WebsiteUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>[]
        }
        upsert: {
          args: Prisma.WebsiteUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsitePayload>
        }
        aggregate: {
          args: Prisma.WebsiteAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateWebsite>
        }
        groupBy: {
          args: Prisma.WebsiteGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.WebsiteGroupByOutputType>[]
        }
        count: {
          args: Prisma.WebsiteCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.WebsiteCountAggregateOutputType> | number
        }
      }
    }
    WebsiteEvent: {
      payload: Prisma.$WebsiteEventPayload<ExtArgs>
      fields: Prisma.WebsiteEventFieldRefs
      operations: {
        findUnique: {
          args: Prisma.WebsiteEventFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.WebsiteEventFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>
        }
        findFirst: {
          args: Prisma.WebsiteEventFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.WebsiteEventFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>
        }
        findMany: {
          args: Prisma.WebsiteEventFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>[]
        }
        create: {
          args: Prisma.WebsiteEventCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>
        }
        createMany: {
          args: Prisma.WebsiteEventCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.WebsiteEventCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>[]
        }
        delete: {
          args: Prisma.WebsiteEventDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>
        }
        update: {
          args: Prisma.WebsiteEventUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>
        }
        deleteMany: {
          args: Prisma.WebsiteEventDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.WebsiteEventUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.WebsiteEventUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>[]
        }
        upsert: {
          args: Prisma.WebsiteEventUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$WebsiteEventPayload>
        }
        aggregate: {
          args: Prisma.WebsiteEventAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateWebsiteEvent>
        }
        groupBy: {
          args: Prisma.WebsiteEventGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.WebsiteEventGroupByOutputType>[]
        }
        count: {
          args: Prisma.WebsiteEventCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.WebsiteEventCountAggregateOutputType> | number
        }
      }
    }
    EventData: {
      payload: Prisma.$EventDataPayload<ExtArgs>
      fields: Prisma.EventDataFieldRefs
      operations: {
        findUnique: {
          args: Prisma.EventDataFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.EventDataFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>
        }
        findFirst: {
          args: Prisma.EventDataFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.EventDataFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>
        }
        findMany: {
          args: Prisma.EventDataFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>[]
        }
        create: {
          args: Prisma.EventDataCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>
        }
        createMany: {
          args: Prisma.EventDataCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.EventDataCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>[]
        }
        delete: {
          args: Prisma.EventDataDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>
        }
        update: {
          args: Prisma.EventDataUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>
        }
        deleteMany: {
          args: Prisma.EventDataDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.EventDataUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.EventDataUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>[]
        }
        upsert: {
          args: Prisma.EventDataUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$EventDataPayload>
        }
        aggregate: {
          args: Prisma.EventDataAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateEventData>
        }
        groupBy: {
          args: Prisma.EventDataGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.EventDataGroupByOutputType>[]
        }
        count: {
          args: Prisma.EventDataCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.EventDataCountAggregateOutputType> | number
        }
      }
    }
    SessionData: {
      payload: Prisma.$SessionDataPayload<ExtArgs>
      fields: Prisma.SessionDataFieldRefs
      operations: {
        findUnique: {
          args: Prisma.SessionDataFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.SessionDataFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>
        }
        findFirst: {
          args: Prisma.SessionDataFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.SessionDataFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>
        }
        findMany: {
          args: Prisma.SessionDataFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>[]
        }
        create: {
          args: Prisma.SessionDataCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>
        }
        createMany: {
          args: Prisma.SessionDataCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.SessionDataCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>[]
        }
        delete: {
          args: Prisma.SessionDataDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>
        }
        update: {
          args: Prisma.SessionDataUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>
        }
        deleteMany: {
          args: Prisma.SessionDataDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.SessionDataUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.SessionDataUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>[]
        }
        upsert: {
          args: Prisma.SessionDataUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionDataPayload>
        }
        aggregate: {
          args: Prisma.SessionDataAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateSessionData>
        }
        groupBy: {
          args: Prisma.SessionDataGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionDataGroupByOutputType>[]
        }
        count: {
          args: Prisma.SessionDataCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionDataCountAggregateOutputType> | number
        }
      }
    }
    Team: {
      payload: Prisma.$TeamPayload<ExtArgs>
      fields: Prisma.TeamFieldRefs
      operations: {
        findUnique: {
          args: Prisma.TeamFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.TeamFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>
        }
        findFirst: {
          args: Prisma.TeamFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.TeamFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>
        }
        findMany: {
          args: Prisma.TeamFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>[]
        }
        create: {
          args: Prisma.TeamCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>
        }
        createMany: {
          args: Prisma.TeamCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.TeamCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>[]
        }
        delete: {
          args: Prisma.TeamDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>
        }
        update: {
          args: Prisma.TeamUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>
        }
        deleteMany: {
          args: Prisma.TeamDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.TeamUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.TeamUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>[]
        }
        upsert: {
          args: Prisma.TeamUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamPayload>
        }
        aggregate: {
          args: Prisma.TeamAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateTeam>
        }
        groupBy: {
          args: Prisma.TeamGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.TeamGroupByOutputType>[]
        }
        count: {
          args: Prisma.TeamCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.TeamCountAggregateOutputType> | number
        }
      }
    }
    TeamUser: {
      payload: Prisma.$TeamUserPayload<ExtArgs>
      fields: Prisma.TeamUserFieldRefs
      operations: {
        findUnique: {
          args: Prisma.TeamUserFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.TeamUserFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>
        }
        findFirst: {
          args: Prisma.TeamUserFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.TeamUserFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>
        }
        findMany: {
          args: Prisma.TeamUserFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>[]
        }
        create: {
          args: Prisma.TeamUserCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>
        }
        createMany: {
          args: Prisma.TeamUserCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.TeamUserCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>[]
        }
        delete: {
          args: Prisma.TeamUserDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>
        }
        update: {
          args: Prisma.TeamUserUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>
        }
        deleteMany: {
          args: Prisma.TeamUserDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.TeamUserUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.TeamUserUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>[]
        }
        upsert: {
          args: Prisma.TeamUserUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$TeamUserPayload>
        }
        aggregate: {
          args: Prisma.TeamUserAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateTeamUser>
        }
        groupBy: {
          args: Prisma.TeamUserGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.TeamUserGroupByOutputType>[]
        }
        count: {
          args: Prisma.TeamUserCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.TeamUserCountAggregateOutputType> | number
        }
      }
    }
    Report: {
      payload: Prisma.$ReportPayload<ExtArgs>
      fields: Prisma.ReportFieldRefs
      operations: {
        findUnique: {
          args: Prisma.ReportFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.ReportFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>
        }
        findFirst: {
          args: Prisma.ReportFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.ReportFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>
        }
        findMany: {
          args: Prisma.ReportFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>[]
        }
        create: {
          args: Prisma.ReportCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>
        }
        createMany: {
          args: Prisma.ReportCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.ReportCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>[]
        }
        delete: {
          args: Prisma.ReportDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>
        }
        update: {
          args: Prisma.ReportUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>
        }
        deleteMany: {
          args: Prisma.ReportDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.ReportUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.ReportUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>[]
        }
        upsert: {
          args: Prisma.ReportUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$ReportPayload>
        }
        aggregate: {
          args: Prisma.ReportAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateReport>
        }
        groupBy: {
          args: Prisma.ReportGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.ReportGroupByOutputType>[]
        }
        count: {
          args: Prisma.ReportCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.ReportCountAggregateOutputType> | number
        }
      }
    }
    Segment: {
      payload: Prisma.$SegmentPayload<ExtArgs>
      fields: Prisma.SegmentFieldRefs
      operations: {
        findUnique: {
          args: Prisma.SegmentFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.SegmentFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>
        }
        findFirst: {
          args: Prisma.SegmentFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.SegmentFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>
        }
        findMany: {
          args: Prisma.SegmentFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>[]
        }
        create: {
          args: Prisma.SegmentCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>
        }
        createMany: {
          args: Prisma.SegmentCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.SegmentCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>[]
        }
        delete: {
          args: Prisma.SegmentDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>
        }
        update: {
          args: Prisma.SegmentUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>
        }
        deleteMany: {
          args: Prisma.SegmentDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.SegmentUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.SegmentUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>[]
        }
        upsert: {
          args: Prisma.SegmentUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SegmentPayload>
        }
        aggregate: {
          args: Prisma.SegmentAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateSegment>
        }
        groupBy: {
          args: Prisma.SegmentGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SegmentGroupByOutputType>[]
        }
        count: {
          args: Prisma.SegmentCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SegmentCountAggregateOutputType> | number
        }
      }
    }
    Revenue: {
      payload: Prisma.$RevenuePayload<ExtArgs>
      fields: Prisma.RevenueFieldRefs
      operations: {
        findUnique: {
          args: Prisma.RevenueFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.RevenueFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>
        }
        findFirst: {
          args: Prisma.RevenueFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.RevenueFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>
        }
        findMany: {
          args: Prisma.RevenueFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>[]
        }
        create: {
          args: Prisma.RevenueCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>
        }
        createMany: {
          args: Prisma.RevenueCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.RevenueCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>[]
        }
        delete: {
          args: Prisma.RevenueDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>
        }
        update: {
          args: Prisma.RevenueUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>
        }
        deleteMany: {
          args: Prisma.RevenueDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.RevenueUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.RevenueUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>[]
        }
        upsert: {
          args: Prisma.RevenueUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$RevenuePayload>
        }
        aggregate: {
          args: Prisma.RevenueAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateRevenue>
        }
        groupBy: {
          args: Prisma.RevenueGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.RevenueGroupByOutputType>[]
        }
        count: {
          args: Prisma.RevenueCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.RevenueCountAggregateOutputType> | number
        }
      }
    }
    Link: {
      payload: Prisma.$LinkPayload<ExtArgs>
      fields: Prisma.LinkFieldRefs
      operations: {
        findUnique: {
          args: Prisma.LinkFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.LinkFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>
        }
        findFirst: {
          args: Prisma.LinkFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.LinkFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>
        }
        findMany: {
          args: Prisma.LinkFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>[]
        }
        create: {
          args: Prisma.LinkCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>
        }
        createMany: {
          args: Prisma.LinkCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.LinkCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>[]
        }
        delete: {
          args: Prisma.LinkDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>
        }
        update: {
          args: Prisma.LinkUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>
        }
        deleteMany: {
          args: Prisma.LinkDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.LinkUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.LinkUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>[]
        }
        upsert: {
          args: Prisma.LinkUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$LinkPayload>
        }
        aggregate: {
          args: Prisma.LinkAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateLink>
        }
        groupBy: {
          args: Prisma.LinkGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.LinkGroupByOutputType>[]
        }
        count: {
          args: Prisma.LinkCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.LinkCountAggregateOutputType> | number
        }
      }
    }
    Pixel: {
      payload: Prisma.$PixelPayload<ExtArgs>
      fields: Prisma.PixelFieldRefs
      operations: {
        findUnique: {
          args: Prisma.PixelFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.PixelFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>
        }
        findFirst: {
          args: Prisma.PixelFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.PixelFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>
        }
        findMany: {
          args: Prisma.PixelFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>[]
        }
        create: {
          args: Prisma.PixelCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>
        }
        createMany: {
          args: Prisma.PixelCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.PixelCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>[]
        }
        delete: {
          args: Prisma.PixelDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>
        }
        update: {
          args: Prisma.PixelUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>
        }
        deleteMany: {
          args: Prisma.PixelDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.PixelUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.PixelUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>[]
        }
        upsert: {
          args: Prisma.PixelUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$PixelPayload>
        }
        aggregate: {
          args: Prisma.PixelAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregatePixel>
        }
        groupBy: {
          args: Prisma.PixelGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.PixelGroupByOutputType>[]
        }
        count: {
          args: Prisma.PixelCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.PixelCountAggregateOutputType> | number
        }
      }
    }
    Board: {
      payload: Prisma.$BoardPayload<ExtArgs>
      fields: Prisma.BoardFieldRefs
      operations: {
        findUnique: {
          args: Prisma.BoardFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.BoardFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>
        }
        findFirst: {
          args: Prisma.BoardFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.BoardFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>
        }
        findMany: {
          args: Prisma.BoardFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>[]
        }
        create: {
          args: Prisma.BoardCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>
        }
        createMany: {
          args: Prisma.BoardCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.BoardCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>[]
        }
        delete: {
          args: Prisma.BoardDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>
        }
        update: {
          args: Prisma.BoardUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>
        }
        deleteMany: {
          args: Prisma.BoardDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.BoardUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.BoardUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>[]
        }
        upsert: {
          args: Prisma.BoardUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$BoardPayload>
        }
        aggregate: {
          args: Prisma.BoardAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateBoard>
        }
        groupBy: {
          args: Prisma.BoardGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.BoardGroupByOutputType>[]
        }
        count: {
          args: Prisma.BoardCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.BoardCountAggregateOutputType> | number
        }
      }
    }
    Share: {
      payload: Prisma.$SharePayload<ExtArgs>
      fields: Prisma.ShareFieldRefs
      operations: {
        findUnique: {
          args: Prisma.ShareFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.ShareFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>
        }
        findFirst: {
          args: Prisma.ShareFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.ShareFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>
        }
        findMany: {
          args: Prisma.ShareFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>[]
        }
        create: {
          args: Prisma.ShareCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>
        }
        createMany: {
          args: Prisma.ShareCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.ShareCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>[]
        }
        delete: {
          args: Prisma.ShareDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>
        }
        update: {
          args: Prisma.ShareUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>
        }
        deleteMany: {
          args: Prisma.ShareDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.ShareUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.ShareUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>[]
        }
        upsert: {
          args: Prisma.ShareUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SharePayload>
        }
        aggregate: {
          args: Prisma.ShareAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateShare>
        }
        groupBy: {
          args: Prisma.ShareGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.ShareGroupByOutputType>[]
        }
        count: {
          args: Prisma.ShareCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.ShareCountAggregateOutputType> | number
        }
      }
    }
    SessionReplay: {
      payload: Prisma.$SessionReplayPayload<ExtArgs>
      fields: Prisma.SessionReplayFieldRefs
      operations: {
        findUnique: {
          args: Prisma.SessionReplayFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.SessionReplayFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>
        }
        findFirst: {
          args: Prisma.SessionReplayFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.SessionReplayFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>
        }
        findMany: {
          args: Prisma.SessionReplayFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>[]
        }
        create: {
          args: Prisma.SessionReplayCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>
        }
        createMany: {
          args: Prisma.SessionReplayCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.SessionReplayCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>[]
        }
        delete: {
          args: Prisma.SessionReplayDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>
        }
        update: {
          args: Prisma.SessionReplayUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>
        }
        deleteMany: {
          args: Prisma.SessionReplayDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.SessionReplayUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.SessionReplayUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>[]
        }
        upsert: {
          args: Prisma.SessionReplayUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplayPayload>
        }
        aggregate: {
          args: Prisma.SessionReplayAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateSessionReplay>
        }
        groupBy: {
          args: Prisma.SessionReplayGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionReplayGroupByOutputType>[]
        }
        count: {
          args: Prisma.SessionReplayCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionReplayCountAggregateOutputType> | number
        }
      }
    }
    SessionReplaySaved: {
      payload: Prisma.$SessionReplaySavedPayload<ExtArgs>
      fields: Prisma.SessionReplaySavedFieldRefs
      operations: {
        findUnique: {
          args: Prisma.SessionReplaySavedFindUniqueArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload> | null
        }
        findUniqueOrThrow: {
          args: Prisma.SessionReplaySavedFindUniqueOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>
        }
        findFirst: {
          args: Prisma.SessionReplaySavedFindFirstArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload> | null
        }
        findFirstOrThrow: {
          args: Prisma.SessionReplaySavedFindFirstOrThrowArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>
        }
        findMany: {
          args: Prisma.SessionReplaySavedFindManyArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>[]
        }
        create: {
          args: Prisma.SessionReplaySavedCreateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>
        }
        createMany: {
          args: Prisma.SessionReplaySavedCreateManyArgs<ExtArgs>
          result: BatchPayload
        }
        createManyAndReturn: {
          args: Prisma.SessionReplaySavedCreateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>[]
        }
        delete: {
          args: Prisma.SessionReplaySavedDeleteArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>
        }
        update: {
          args: Prisma.SessionReplaySavedUpdateArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>
        }
        deleteMany: {
          args: Prisma.SessionReplaySavedDeleteManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateMany: {
          args: Prisma.SessionReplaySavedUpdateManyArgs<ExtArgs>
          result: BatchPayload
        }
        updateManyAndReturn: {
          args: Prisma.SessionReplaySavedUpdateManyAndReturnArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>[]
        }
        upsert: {
          args: Prisma.SessionReplaySavedUpsertArgs<ExtArgs>
          result: runtime.Types.Utils.PayloadToResult<Prisma.$SessionReplaySavedPayload>
        }
        aggregate: {
          args: Prisma.SessionReplaySavedAggregateArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.AggregateSessionReplaySaved>
        }
        groupBy: {
          args: Prisma.SessionReplaySavedGroupByArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionReplaySavedGroupByOutputType>[]
        }
        count: {
          args: Prisma.SessionReplaySavedCountArgs<ExtArgs>
          result: runtime.Types.Utils.Optional<Prisma.SessionReplaySavedCountAggregateOutputType> | number
        }
      }
    }
  }
} & {
  other: {
    payload: any
    operations: {
      $executeRaw: {
        args: [query: TemplateStringsArray | Sql, ...values: any[]],
        result: any
      }
      $executeRawUnsafe: {
        args: [query: string, ...values: any[]],
        result: any
      }
      $queryRaw: {
        args: [query: TemplateStringsArray | Sql, ...values: any[]],
        result: any
      }
      $queryRawUnsafe: {
        args: [query: string, ...values: any[]],
        result: any
      }
    }
  }
}

/**
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  username: 'username',
  password: 'password',
  role: 'role',
  logoUrl: 'logoUrl',
  displayName: 'displayName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  browser: 'browser',
  os: 'os',
  device: 'device',
  screen: 'screen',
  language: 'language',
  country: 'country',
  region: 'region',
  city: 'city',
  distinctId: 'distinctId',
  createdAt: 'createdAt'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const WebsiteScalarFieldEnum = {
  id: 'id',
  name: 'name',
  domain: 'domain',
  resetAt: 'resetAt',
  userId: 'userId',
  teamId: 'teamId',
  createdBy: 'createdBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  replayEnabled: 'replayEnabled',
  replayConfig: 'replayConfig'
} as const

export type WebsiteScalarFieldEnum = (typeof WebsiteScalarFieldEnum)[keyof typeof WebsiteScalarFieldEnum]


export const WebsiteEventScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  sessionId: 'sessionId',
  visitId: 'visitId',
  createdAt: 'createdAt',
  urlPath: 'urlPath',
  urlQuery: 'urlQuery',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmContent: 'utmContent',
  utmTerm: 'utmTerm',
  referrerPath: 'referrerPath',
  referrerQuery: 'referrerQuery',
  referrerDomain: 'referrerDomain',
  pageTitle: 'pageTitle',
  gclid: 'gclid',
  fbclid: 'fbclid',
  msclkid: 'msclkid',
  ttclid: 'ttclid',
  lifatid: 'lifatid',
  twclid: 'twclid',
  eventType: 'eventType',
  eventName: 'eventName',
  tag: 'tag',
  hostname: 'hostname',
  lcp: 'lcp',
  inp: 'inp',
  cls: 'cls',
  fcp: 'fcp',
  ttfb: 'ttfb'
} as const

export type WebsiteEventScalarFieldEnum = (typeof WebsiteEventScalarFieldEnum)[keyof typeof WebsiteEventScalarFieldEnum]


export const EventDataScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  websiteEventId: 'websiteEventId',
  dataKey: 'dataKey',
  stringValue: 'stringValue',
  numberValue: 'numberValue',
  dateValue: 'dateValue',
  dataType: 'dataType',
  createdAt: 'createdAt'
} as const

export type EventDataScalarFieldEnum = (typeof EventDataScalarFieldEnum)[keyof typeof EventDataScalarFieldEnum]


export const SessionDataScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  sessionId: 'sessionId',
  dataKey: 'dataKey',
  stringValue: 'stringValue',
  numberValue: 'numberValue',
  dateValue: 'dateValue',
  dataType: 'dataType',
  distinctId: 'distinctId',
  createdAt: 'createdAt'
} as const

export type SessionDataScalarFieldEnum = (typeof SessionDataScalarFieldEnum)[keyof typeof SessionDataScalarFieldEnum]


export const TeamScalarFieldEnum = {
  id: 'id',
  name: 'name',
  accessCode: 'accessCode',
  logoUrl: 'logoUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type TeamScalarFieldEnum = (typeof TeamScalarFieldEnum)[keyof typeof TeamScalarFieldEnum]


export const TeamUserScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  userId: 'userId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TeamUserScalarFieldEnum = (typeof TeamUserScalarFieldEnum)[keyof typeof TeamUserScalarFieldEnum]


export const ReportScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  websiteId: 'websiteId',
  type: 'type',
  name: 'name',
  description: 'description',
  parameters: 'parameters',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReportScalarFieldEnum = (typeof ReportScalarFieldEnum)[keyof typeof ReportScalarFieldEnum]


export const SegmentScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  type: 'type',
  name: 'name',
  parameters: 'parameters',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SegmentScalarFieldEnum = (typeof SegmentScalarFieldEnum)[keyof typeof SegmentScalarFieldEnum]


export const RevenueScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  sessionId: 'sessionId',
  eventId: 'eventId',
  eventName: 'eventName',
  currency: 'currency',
  revenue: 'revenue',
  createdAt: 'createdAt'
} as const

export type RevenueScalarFieldEnum = (typeof RevenueScalarFieldEnum)[keyof typeof RevenueScalarFieldEnum]


export const LinkScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  slug: 'slug',
  userId: 'userId',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type LinkScalarFieldEnum = (typeof LinkScalarFieldEnum)[keyof typeof LinkScalarFieldEnum]


export const PixelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  userId: 'userId',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type PixelScalarFieldEnum = (typeof PixelScalarFieldEnum)[keyof typeof PixelScalarFieldEnum]


export const BoardScalarFieldEnum = {
  id: 'id',
  type: 'type',
  name: 'name',
  description: 'description',
  parameters: 'parameters',
  userId: 'userId',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BoardScalarFieldEnum = (typeof BoardScalarFieldEnum)[keyof typeof BoardScalarFieldEnum]


export const ShareScalarFieldEnum = {
  id: 'id',
  entityId: 'entityId',
  name: 'name',
  shareType: 'shareType',
  slug: 'slug',
  parameters: 'parameters',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ShareScalarFieldEnum = (typeof ShareScalarFieldEnum)[keyof typeof ShareScalarFieldEnum]


export const SessionReplayScalarFieldEnum = {
  id: 'id',
  websiteId: 'websiteId',
  sessionId: 'sessionId',
  visitId: 'visitId',
  chunkIndex: 'chunkIndex',
  events: 'events',
  eventCount: 'eventCount',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  createdAt: 'createdAt'
} as const

export type SessionReplayScalarFieldEnum = (typeof SessionReplayScalarFieldEnum)[keyof typeof SessionReplayScalarFieldEnum]


export const SessionReplaySavedScalarFieldEnum = {
  id: 'id',
  name: 'name',
  websiteId: 'websiteId',
  visitId: 'visitId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionReplaySavedScalarFieldEnum = (typeof SessionReplaySavedScalarFieldEnum)[keyof typeof SessionReplaySavedScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]



/**
 * Field references
 */


/**
 * Reference to a field of type 'String'
 */
export type StringFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'String'>
    


/**
 * Reference to a field of type 'String[]'
 */
export type ListStringFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'String[]'>
    


/**
 * Reference to a field of type 'DateTime'
 */
export type DateTimeFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'DateTime'>
    


/**
 * Reference to a field of type 'DateTime[]'
 */
export type ListDateTimeFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'DateTime[]'>
    


/**
 * Reference to a field of type 'Boolean'
 */
export type BooleanFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Boolean'>
    


/**
 * Reference to a field of type 'Json'
 */
export type JsonFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Json'>
    


/**
 * Reference to a field of type 'QueryMode'
 */
export type EnumQueryModeFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'QueryMode'>
    


/**
 * Reference to a field of type 'Int'
 */
export type IntFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Int'>
    


/**
 * Reference to a field of type 'Int[]'
 */
export type ListIntFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Int[]'>
    


/**
 * Reference to a field of type 'Decimal'
 */
export type DecimalFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Decimal'>
    


/**
 * Reference to a field of type 'Decimal[]'
 */
export type ListDecimalFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Decimal[]'>
    


/**
 * Reference to a field of type 'Bytes'
 */
export type BytesFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Bytes'>
    


/**
 * Reference to a field of type 'Bytes[]'
 */
export type ListBytesFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Bytes[]'>
    


/**
 * Reference to a field of type 'Float'
 */
export type FloatFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Float'>
    


/**
 * Reference to a field of type 'Float[]'
 */
export type ListFloatFieldRefInput<$PrismaModel> = FieldRefInputType<$PrismaModel, 'Float[]'>
    

/**
 * Batch Payload for updateMany & deleteMany & createMany
 */
export type BatchPayload = {
  count: number
}

export const defineExtension = runtime.Extensions.defineExtension as unknown as runtime.Types.Extensions.ExtendsHook<"define", TypeMapCb, runtime.Types.Extensions.DefaultArgs>
export type DefaultPrismaClient = PrismaClient
export type ErrorFormat = 'pretty' | 'colorless' | 'minimal'
export type PrismaClientOptions = ({
  /**
   * Instance of a Driver Adapter, e.g., like one provided by `@prisma/adapter-pg`.
   */
  adapter: runtime.SqlDriverAdapterFactory
  accelerateUrl?: never
} | {
  /**
   * Prisma Accelerate URL allowing the client to connect through Accelerate instead of a direct database.
   */
  accelerateUrl: string
  adapter?: never
}) & {
  /**
   * @default "colorless"
   */
  errorFormat?: ErrorFormat
  /**
   * @example
   * ```
   * // Shorthand for `emit: 'stdout'`
   * log: ['query', 'info', 'warn', 'error']
   * 
   * // Emit as events only
   * log: [
   *   { emit: 'event', level: 'query' },
   *   { emit: 'event', level: 'info' },
   *   { emit: 'event', level: 'warn' }
   *   { emit: 'event', level: 'error' }
   * ]
   * 
   * / Emit as events and log to stdout
   * og: [
   *  { emit: 'stdout', level: 'query' },
   *  { emit: 'stdout', level: 'info' },
   *  { emit: 'stdout', level: 'warn' }
   *  { emit: 'stdout', level: 'error' }
   * 
   * ```
   * Read more in our [docs](https://pris.ly/d/logging).
   */
  log?: (LogLevel | LogDefinition)[]
  /**
   * The default values for transactionOptions
   * maxWait ?= 2000
   * timeout ?= 5000
   */
  transactionOptions?: {
    maxWait?: number
    timeout?: number
    isolationLevel?: TransactionIsolationLevel
  }
  /**
   * Global configuration for omitting model fields by default.
   * 
   * @example
   * ```
   * const prisma = new PrismaClient({
   *   omit: {
   *     user: {
   *       password: true
   *     }
   *   }
   * })
   * ```
   */
  omit?: GlobalOmitConfig
  /**
   * SQL commenter plugins that add metadata to SQL queries as comments.
   * Comments follow the sqlcommenter format: https://google.github.io/sqlcommenter/
   * 
   * @example
   * ```
   * const prisma = new PrismaClient({
   *   adapter,
   *   comments: [
   *     traceContext(),
   *     queryInsights(),
   *   ],
   * })
   * ```
   */
  comments?: runtime.SqlCommenterPlugin[]
  /**
   * Optional maximum size for the query plan cache. If not provided, a default size will be used.
   * A value of `0` can be used to disable the cache entirely. A higher cache size can improve
   * performance for applications that execute a large number of unique queries, while a smaller
   * cache size can reduce memory usage.
   * 
   * @example
   * ```
   * const prisma = new PrismaClient({
   *   adapter,
   *   queryPlanCacheMaxSize: 100,
   * })
   * ```
   */
  queryPlanCacheMaxSize?: number
}
export type GlobalOmitConfig = {
  user?: Prisma.UserOmit
  session?: Prisma.SessionOmit
  website?: Prisma.WebsiteOmit
  websiteEvent?: Prisma.WebsiteEventOmit
  eventData?: Prisma.EventDataOmit
  sessionData?: Prisma.SessionDataOmit
  team?: Prisma.TeamOmit
  teamUser?: Prisma.TeamUserOmit
  report?: Prisma.ReportOmit
  segment?: Prisma.SegmentOmit
  revenue?: Prisma.RevenueOmit
  link?: Prisma.LinkOmit
  pixel?: Prisma.PixelOmit
  board?: Prisma.BoardOmit
  share?: Prisma.ShareOmit
  sessionReplay?: Prisma.SessionReplayOmit
  sessionReplaySaved?: Prisma.SessionReplaySavedOmit
}

/* Types for Logging */
export type LogLevel = 'info' | 'query' | 'warn' | 'error'
export type LogDefinition = {
  level: LogLevel
  emit: 'stdout' | 'event'
}

export type CheckIsLogLevel<T> = T extends LogLevel ? T : never;

export type GetLogType<T> = CheckIsLogLevel<
  T extends LogDefinition ? T['level'] : T
>;

export type GetEvents<T extends any[]> = T extends Array<LogLevel | LogDefinition>
  ? GetLogType<T[number]>
  : never;

export type QueryEvent = {
  timestamp: Date
  query: string
  params: string
  duration: number
  target: string
}

export type LogEvent = {
  timestamp: Date
  message: string
  target: string
}
/* End Types for Logging */


export type PrismaAction =
  | 'findUnique'
  | 'findUniqueOrThrow'
  | 'findMany'
  | 'findFirst'
  | 'findFirstOrThrow'
  | 'create'
  | 'createMany'
  | 'createManyAndReturn'
  | 'update'
  | 'updateMany'
  | 'updateManyAndReturn'
  | 'upsert'
  | 'delete'
  | 'deleteMany'
  | 'executeRaw'
  | 'queryRaw'
  | 'aggregate'
  | 'count'
  | 'runCommandRaw'
  | 'findRaw'
  | 'groupBy'

/**
 * `PrismaClient` proxy available in interactive transactions.
 */
export type TransactionClient = Omit<DefaultPrismaClient, runtime.ITXClientDenyList>

